module.exports = __webpack_public_path__ + "a27c290b1227336d0a32c14c6df479d7.svg";